export default [
  {
    path: '/apps/item/list',
    name: 'apps-item-list',
    component: () => import('@/views/cadastros-gerais/item/list/Index.vue'),
    meta: {
      pageTitle: 'Item',
      resource: 'AdminHanes',
    },
  },
  {
    path: '/apps/item/edit/:id',
    name: 'apps-item-edit',
    component: () => import('@/views/cadastros-gerais/item/edit-add/Index.vue'),
    meta: {
      pageTitle: 'Editar Item',
      resource: 'AdminHanes',
    },
    options: { transition: 'zoom-in' },
  },
];
